import { OreButton, OreStack } from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useAutoEnrollment } from '@/AutoEnrollment/ui/context'
import { Step1Form } from '@/AutoEnrollment/ui/hooks'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const Step1Actions = (): JSX.Element => {
  const { t } = useTranslation()
  const { handleSubmit } = useFormContext<Step1Form>()
  const { saveStep1 } = useAutoEnrollment()

  return (
    <OreStack space="large" direction="row" placeContent="end">
      <OreButton
        category={'primary'}
        onClick={handleSubmit(saveStep1)}
        data-testid="saveStepOne"
      >
        {t(formTranslation.common.buttons.saveAndContinue)}
      </OreButton>
    </OreStack>
  )
}
